import { todoTask, ownerTask, getFlowContentTypeList, getFlowNodesByContentType, getAllUser } from '../../apis/httpHelper'
import { qweIsEmpty, singleDataConvert } from '../../common/commonHelper'
import { ResponseCode } from "../../common/constant"
import { FormEvent } from "../Form"
import dayjs from "@/utils/dayjs"
import { TaskType } from "."

export default {
    props:["taskType"],
    data:function() {
        return {
            loading:false,
            total:0,

            dataItems: [],
            skip:0,
            getItemsLoading:false,
            filterLoading:false,

            userOptionsProps:{
                label: 'Text',
                value: 'Value',
            },

            filterItem:{
                filterState:false,
                contentType:"",
                owner:"",
                createdUtc:[],
                flowNode:"",
                flowState:""
            },

            filterOptions:{
                userOptions:[],
                contentTypeOptions:[],
                nodeOptions:[]
            },
            filterVisibleState:false,

            sortVisibleState:false,
            sortDesc:true,

            formEvent:FormEvent,
            formItem: {
                operation: "",
                contentType: "",
                contentItemId: "",
                flowCurrentNodeId: "",
                title: "",
                passingParameter: []
            },

            taskTypeOptions:TaskType
        }
    },
    created:function(){
        this.initFilter();
        this.load(true);
    },

    watch:{
        "filterItem.contentType":function(newVal, oldVal){
            if(!qweIsEmpty(newVal)){
                this.handlerFlowNodes(newVal)
            }
        }
    },

    computed:{
        cardShowColumns:function(){
            return this.showColumnOptions.filter(x=> this.showColumns.includes(x.name));
        },

        scrollDisabled:function(){
            return this.loading || this.noMore
        },

        noMore:function(){
            return this.skip >= this.total
        },

        isTodoTask:function(){
            return this.taskType == TaskType.ToDoTask
        }
    },

    methods:{
        initFilter:function(){
            getFlowContentTypeList().then(x=> this.filterOptions.contentTypeOptions = x.Result);
            if(this.taskType != TaskType.OwnerTask){
                getAllUser().then(x=> this.filterOptions.userOptions = x.Result.Options.map(y=> {
                    return {label:y.Text, value:y.Value};
                }));
            }
        },

        showFilter:function(){
            this.filterVisibleState = true;
            this.sortVisibleState = false;
        },

        handlerFlowNodes:function(newVal){
            getFlowNodesByContentType(newVal).then(x=> this.filterOptions.nodeOptions = x.Result);
        },

        showSort:function(){
            this.filterVisibleState = false;
            this.sortVisibleState = true;
        },

        queryFilter:function(){
            this.getDataItems(true);
            this.filterVisibleState = false;
        },

        resetFilter:function(){
            this.filterItem.contentType = "";
            this.filterItem.owner = "";
            this.filterItem.createdUtc = [];
            this.filterItem.flowNode = "";
            this.filterItem.flowState = "";
        },

        sortTask:function(sort){
            this.sortVisibleState = false;
            this.sortDesc = sort;
            this.getDataItems(true);
        },

        fromInit:function (code, formBuilder){
            if (code === ResponseCode.Success) {
                this.formItem.title = formBuilder.CurrentDisplayName;
            }
            else if(code == ResponseCode.UnAuthoized){
                this.formItem.visibleState = false;
                ElMessage.error("无权限")
            }
            else{
                this.formItem.visibleState = false;
            }
        },

        formSubmit:function(operator, code){
            if(operator !=  FormEvent.draft){
                if(code == ResponseCode.Success || code == ResponseCode.SuccessAndWarn){
                    this.formItem.visibleState = false;
                    this.load();
                }
            }
        },

        load:function(){
            if(this.skip <= this.total){
                this.getDataItems(false);
            }
        },

        getDataItems:function(reset){
            this.loading = true;
            if(reset){
                this.skip = 0;
            }

            let getTask;

            if(this.taskType == TaskType.ToDoTask){
                getTask = todoTask(
                    this.skip, {
                        ContentType : this.filterItem.contentType,
                        Owner : this.filterItem.owner,
                        CreatedUtc : this.filterItem.createdUtc,
                        FlowNode : this.filterItem.flowNode
                    },
                    this.sortDesc
                )
            }
            else if(this.taskType == TaskType.OwnerTask){
                getTask = ownerTask(
                    this.skip, {
                        FlowState: this.filterItem.flowState,
                        ContentType : this.filterItem.contentType,
                        CreatedUtc : this.filterItem.createdUtc,
                        FlowNode : this.filterItem.flowNode
                    },
                    this.sortDesc
                )
            }
            else{
                getTask = todoTask(
                    this.skip, {
                        ContentType : this.filterItem.contentType,
                        Owner : this.filterItem.owner,
                        CreatedUtc : this.filterItem.createdUtc,
                        FlowNode : this.filterItem.flowNode
                    },
                    this.sortDesc
                )
            }
            getTask
            .then(x=>{
                let responseData = this.dataConvert(x.Result.data);
                if(reset){
                    this.dataItems = responseData;                        
                }
                else{
                    this.dataItems = (this.dataItems || []).concat(responseData);
                }
                this.total = x.Result.total;
                this.getItemsLoading = false;
                this.loading = false;
                this.skip = this.skip + 20;
            }).catch(x=>{
                console.log(x)
            })
        },

        dataConvert:function(datas){
            datas.forEach(dataItem => {
                dataItem.CreatedUtc = dayjs(dataItem.CreateTime).isValid() ? dayjs(dataItem.CreateTime).format("YYYY-MM-DD HH:mm:ss") : "" 
                dataItem.Fields.forEach(field=>{
                    field.Value = singleDataConvert(field.Value, field.Type)
                })
            });
            return datas;
        },

        editItem:function(dataItem){
            let contentItemId = dataItem.ContentItemId;
            let nodeId = dataItem.NodeId;
            this.formItem.contentItemId = contentItemId;
            this.formItem.operation = "Edit";
            this.formItem.flowCurrentNodeId = nodeId;
            this.formItem.title = dataItem.ContentType + "-" + dataItem.NodeName;
            this.formItem.visibleState = true;
        }
    }
}